import { render, staticRenderFns } from "./FailureAttempts.vue?vue&type=template&id=31413f2d&scoped=true"
import script from "./FailureAttempts.vue?vue&type=script&lang=js"
export * from "./FailureAttempts.vue?vue&type=script&lang=js"
import style0 from "./FailureAttempts.vue?vue&type=style&index=0&id=31413f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31413f2d",
  null
  
)

export default component.exports